"use strict";

const { isString } = require("./strings");

/**
 * This provides a common, easy way to parse JSON strings.
 * @param {object} val
 * @param {object | array} defaultValue
 * @returns {object | array}
 */
function fromJsonString(val, defaultValue = undefined) {
  if (!isString(val)) {
    return val || defaultValue;
  }
  try {
    return JSON.parse(val);
  } catch (error) {
    return val || defaultValue;
  }
}

module.exports = {
  fromJsonString
};
